<template>
    <div class="travelsearch">
        <div class="search-box">
            <div class="input-box">
                <img src="../../assets/travelAgency/ic_search.png" alt class="search-icon" />
                <input
                    style
                    type="text"
                    placeholder="搜索导游名称或者导游证号"
                    class="search-input"
                    v-model="inputValue"
                    @input="onChange"
                />
            </div>
            <div class="search-btn" @click="$router.go(-1)">取消</div>
        </div>
        <div class="latest-box" v-if="inputValue == '' && keyword.length > 0">
            <div class="title-box">
                <div class="title">最近搜索</div>
                <img
                    src="../../assets/travelAgency/ic_delete.png"
                    alt
                    class="delete-icon"
                    @click="latestDelete"
                />
            </div>
            <div class="tags-box">
                <div
                    class="tag"
                    v-for="(lists,index) in keyword"
                    :key="index"
                    @click="inputValue = lists,onChange(lists) "
                >{{lists}}</div>
            </div>
        </div>
        <div class="history-box" v-if="inputValue == '' && history.length > 0">
            <div class="title-box">
                <div class="title">浏览历史</div>
                <img
                    src="../../assets/travelAgency/ic_delete.png"
                    alt
                    class="delete-icon"
                    @click="historyDelete"
                />
            </div>
            <div class="lists-box">
                <div
                    class="items-box line_bottom"
                    @click="toDetail(items)"
                    v-for="(items,index) in history"
                    :key="index"
                >
                    <div
                        class="agency-img"
                        v-if="items.photoPath && items.photoPath !=='' && items.photoPath !=='http://images-1254950508.cosgz.myqcloud.com/a4061d82e-214b-4dd7-b3d8-31361432b131.png'"
                        :style="'background-image:url(' + items.photoPath + ');'"
                    ></div>
                    <div class="agency-img" v-else :style="'border: 0'"></div>
                    <!-- <div class="agency-img" :style="'background:url(' + items.photoPath + ');background-size: auto 100%;background-position:center;background-repeat: no-repeat;'"></div> -->
                    <!-- <img :src="items.photoPath" alt class="agency-img" /> -->
                    <div class="info-box">
                        <div class="company-name">
                            <div class="name">{{items.name || items.NAME}}</div>
                            <div class="right-tag-box">
                                <div class="right-tag" v-if="items.isSupervise !== 0">
                                    <div class="label">重点关注</div></div>
                                <div class="right-tag tag-color" v-if="items.isBlacklist != 0">
                                    <div class="label">黑名单</div></div>
                            </div>
                        </div>

                        <div class="tag-box">
                            <div class="left-box">
                                <div class="tags">
                                    <div class="txt">{{items.guideTypeStr}}导游</div>
                                    <star :name="items.certificate" :num="items.guideLevel"></star>
                                </div>
                            </div>
                        </div>
                        <div class="prices-box">
                            <div class="tags">评分 {{items.guideScore || 0}} 分</div>
                            <div class="tags">投诉 {{items.complaintTime || 0}} 次</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="result-box" v-if="inputValue != ''">
            <div class="title-box">
                <div class="title">搜索结果</div>
            </div>
            <div class="lists-box">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="loadMoreList"
                    v-if="listData.length > 0"
                >
                    <div
                        class="items-box line_bottom"
                        @click="toDetail(items)"
                        v-for="(items,index) in listData"
                        :key="index"
                    >
                        <div
                            class="agency-img"
                            v-if="items.photoPath && items.photoPath !=='' && items.photoPath !=='http://images-1254950508.cosgz.myqcloud.com/a4061d82e-214b-4dd7-b3d8-31361432b131.png'"
                            :style="'background-image:url(' + items.photoPath + ');'"
                        ></div>
                        <div class="agency-img" v-else :style="'border: 0'"></div>
                        <!-- <div class="agency-img" :style="'background:url(' + items.photoPath + ');background-size: auto 100%;background-position:center;background-repeat: no-repeat;'"></div> -->
                        <!-- <img :src="items.photoPath" alt class="agency-img" /> -->
                        <div class="info-box">
                            <div class="company-name">
                                <div class="name">{{items.name || items.NAME}}</div>
                                <div class="right-tag-box">
                                    <div class="right-tag" v-if="items.isSupervise !== 0">

                                        <div class="label">重点关注</div></div>
                                    <div
                                        class="right-tag tag-color"
                                        v-if="items.isBlacklist != 0"
                                    >
                                        <div class="label">黑名单</div></div>
                                </div>
                            </div>

                            <div class="tag-box">
                                <div class="left-box">
                                    <div class="tags">
                                        <div class="txt">{{items.guideTypeStr}}导游</div>
                                        <star :name="items.certificate" :num="items.guideLevel"></star>
                                    </div>
                                </div>
                            </div>
                            <div class="prices-box">
                                <div class="tags">评分 {{items.guideScore || 0}}分</div>
                                <div class="tags">投诉 {{items.complaintTime || 0}} 次</div>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <empty :type="2" v-if="listData.length === 0 && !loading"></empty>
        </div>
    </div>
</template>
<script>
    import api from '../../service/modules/guide';
    import { mapState } from 'vuex';
    import empty from 'comps/empty';
    import star from 'comps/star';
    export default {
        components: {
            star,
            empty
        },

        data () {
            return {
                inputValue: '',
                historyClone: [
                    {
                        id: '1',
                        imgurl: '',
                        names: '沈慧芳',
                        tag: '重点关注',
                        type: 1,
                        lefttags: '初级导游',
                        rightscore: '3',
                        pricetag: [
                            {
                                name: '评分',
                                value: '7.11分'
                            },
                            {
                                name: '投诉',
                                value: '12次'
                            }
                        ]
                    },
                    {
                        id: '2',
                        imgurl: '',
                        names: '沈慧芳',
                        lefttags: '初级导游',
                        tag: '重点关注',
                        type: 2,
                        rightscore: '3',
                        pricetag: [
                            {
                                name: '评分',
                                value: '7.11分'
                            },
                            {
                                name: '投诉',
                                value: '12次'
                            }
                        ]
                    },
                    {
                        id: '3',
                        imgurl: '',
                        names: '沈慧芳',
                        lefttags: '初级导游',
                        tag: '重点关注',
                        type: 1,
                        rightscore: '3',
                        pricetag: [
                            {
                                name: '评分',
                                value: '7.11分'
                            },
                            {
                                name: '投诉',
                                value: '12次'
                            }
                        ]
                    }
                ],
                listData: [],
                finished: false,
                loading: false,
                page: 1,
                total: 0,
                oldInputValue: '',
                cityId: ''
            };
        },

        computed: {
            ...mapState('guide', ['history', 'keyword'])
        },

        watch: {},

        methods: {
            loadMoreList () {
                this.getData();
            },
            getData () {
                if (this.inputValue && !this.keyword.includes(this.inputValue)) {
                    this.$store.dispatch('guide/setKeyword', [
                        this.inputValue,
                        ...this.keyword
                    ]); // 设置搜索记录
                }
                this.loading = true;
                let data = {
                    type: '',
                    p: this.page,
                    pageSize: 8,
                    keyword: this.inputValue,
                    city: (Number(this.cityId) === 34 || this.cityId == 0) ? '' : this.cityId
                };
                api.guidePage(data).then(res => {
                    if (res.ret === 0) {
                        this.loading = false;
                        this.finished = false;
                        this.listData = [...this.listData, ...res.data.list];
                        this.page = res.data.pagination.current_page + 1;
                        this.total = res.data.pagination.total;
                        if (
                            this.total <=
                            res.data.pagination.current_page *
                            res.data.pagination.page_size
                        ) {
                            this.finished = true;
                        }
                    } else {
                        this.$Toast('请输入合法字符');
                    }
                });
            },
            toDetail (item) {
                let list = [];
                list.push(item);
                this.history.forEach(element => {
                    if (element.id !== item.id && list.length < 10) {
                        list.push(element);
                    }
                });
                this.$store.dispatch('guide/setHistory', list); // 设置浏览记录
                this.$router.push({
                    path: '/guide/info',
                    query: {
                        guideId: item.id,
                        isBlacklist: item.isBlacklist,
                        isSupervise: item.isSupervise
                    }
                });
            },
            latestDelete () {
                this.$store.dispatch('guide/setKeyword', []); // 清空搜索记录
            },
            historyDelete () {
                this.$store.dispatch('guide/setHistory', []); // 清空浏览记录
            },
            onChange (value) {
                if (this.inputValue === '') {
                    this.oldInputValue = ''
                    this.listData = this.history;
                    this.finished = true;
                    this.listData = [];
                } else {
                    this.inputValue = this.inputValue.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '');
                    if (this.oldInputValue !== this.inputValue) {
                        this.oldInputValue = this.inputValue;
                        this.page = 1;
                        this.listData = [];
                        if (!this.loading) {
                            this.getData();
                        }
                    }
                }
            }
        },

        mounted () {
            this.inputValue = this.$route.query.inputValue || '';
            this.cityId = this.$route.query.selfCityId || '';
            this.cityId = (this.cityId === 34 || this.cityId == 0)? '' : this.cityId;
            this.getData();
        },
        created () {
            this.$store.dispatch('guide/loadKeyword') // 搜索key
            this.$store.dispatch('guide/loadHistory') // 搜索结果
        }
    };
</script>
<style scoped lang="less">
@vv: 3.75vw;
.travelsearch {
    width: 100%;
    height: 100%;
    background: rgba(251, 251, 251, 1);
    box-sizing: border-box;
    padding: 10/@vv 12/@vv 0 12/@vv;
    .search-box {
        height: 28/@vv;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 25/@vv;
        .input-box {
            flex: 1;
            margin-right: 12/@vv;
            height: 100%;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            padding-left: 16/@vv;
            background: rgba(245, 245, 245, 1);
            border-radius: 1/@vv;
            .search-icon {
                width: 15/@vv;
                // height: 14/@vv;
                margin-right: 8/@vv;
            }
            input::-webkit-input-placeholder {
                font-size: 12/@vv;

                font-weight: 400;
                color: rgba(153, 153, 153, 1);
                line-height: 17/@vv;
            }

            .search-input {
                flex: 1;
                background: rgba(245, 245, 245, 1);
            }
        }
        .search-btn {
            width: 40/@vv;
            height: 28/@vv;
            background: rgba(245, 245, 245, 1);
            border-radius: 1/@vv;
            font-size: 12/@vv;

            font-weight: 400;
            color: rgba(54, 179, 116, 1);
            line-height: 28/@vv;
            text-align: center;
        }
    }
    .latest-box {
        margin-bottom: 28/@vv;

        .title-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12/@vv;

            .title {
                font-size: 16/@vv;

                font-family: PingFang SC, Arial, sans-serif;
                -webkit-font-smoothing: antialiased;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 16/@vv;
            }
            .delete-icon {
                width: 18/@vv;
                height: 18/@vv;
            }
        }
        .tags-box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            .tag {
                font-size: 12/@vv;
                font-family: PingFangTC-Regular, PingFangTC;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
                line-height: 28/@vv;
                box-sizing: border-box;
                padding: 0 8/@vv;
                background: rgba(255, 255, 255, 1);
                border-radius: 1/@vv;
                border: 1/@vv solid rgba(204, 204, 204, 1);
                margin-right: 16/@vv;
                margin-bottom: 10/@vv;
            }
        }
    }
    .history-box,
    .result-box {
        .title-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12/@vv;

            .title {
                font-size: 16/@vv;

                font-family: PingFang SC, Arial, sans-serif;
                -webkit-font-smoothing: antialiased;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                line-height: 16/@vv;
            }
            .delete-icon {
                width: 18/@vv;
                height: 18/@vv;
            }
        }
        .lists-box {
            background: rgba(255, 255, 255, 1);
            box-shadow: 0/@vv 0/@vv 10/@vv 0/@vv rgba(0, 0, 0, 0.04);
            border-radius: 3/@vv;

            .items-box {
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 16/@vv 10/@vv 16/@vv 16/@vv;
                // border-bottom: 1/@vv solid #eeeeee;

                &:last-child {
                    border-bottom: none;
                }

                .agency-img {
                    width: 64/@vv;
                    height: 64/@vv;
                    margin-right: 12/@vv;
                    background: url(../../assets/travelAgency/ic_bm_cy1.png);
                    background-size: auto 100%;
                    background-position: center;
                    background-repeat: no-repeat;
                    border-radius: 3/@vv;
                    border: 1/@vv solid rgba(238, 238, 238, 1);
                    // object-fit: cover
                }

                .info-box {
                    flex: 1;
                    height: 64/@vv;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .company-name {
                        display: flex;
                        justify-content: space-between;
                        position: relative;
                        .name {
                            font-size: 14/@vv;
                            font-family: PingFang SC, Arial, sans-serif;
                            -webkit-font-smoothing: antialiased;
                            font-weight: 500;
                            color: rgba(51, 51, 51, 1);
                            line-height: 20/@vv;
                        }
                        .right-tag-box {
                            position: absolute;
                            display: flex;
                            align-items: center;
                            transform: scale(0.5);
                            transform-origin: right 0;
                            flex: 1;
                            justify-content: flex-end;
                            top: 0;
                            right: 6/@vv;
                            .right-tag {
                                display: table;
                                padding: 0 8/@vv;
                                text-align: center;
                                margin-left: 16/@vv;
                                min-width: 96/@vv;
                                height: 34/@vv;
                                // line-height: 34/@vv;
                                background: rgba(255, 140, 25, 1);
                                // border-radius:1/@vv;
                                font-size: 20/@vv;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: rgba(255, 255, 255, 1);
                                .label {
                                    height: 34/@vv;
                                    line-height: 34/@vv;
                                    display: table-cell;
                                    vertical-align: middle;
                                    white-space:nowrap;
                                }
                            }
                            .tag-color {
                                background: rgba(255, 77, 77, 1);
                            }
                        }
                    }

                    .tag-box {
                        height: 14/@vv;
                        display: flex;
                        align-items: center;
                        margin: 8/@vv 0;

                        .left-box {
                            flex: 1;
                            display: flex;

                            .tags {
                                display: flex;
                                align-items: center;
                                .txt {
                                    font-size: 12/@vv;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: rgba(153, 153, 153, 1);
                                    margin-right: 4/@vv;
                                }
                            }
                        }
                    }

                    .prices-box {
                        display: flex;
                        align-items: center;

                        .tags {
                            font-size: 10/@vv;

                            font-weight: 400;
                            color: rgba(102, 102, 102, 1);
                            line-height: 14/@vv;
                            box-sizing: border-box;
                            padding-left: 7/@vv;
                            padding-right: 8/@vv;
                            border-right: 1/@vv solid #979797;
                            // margin-right: 7/@vv;

                            &:first-child {
                                padding-left: 0;
                            }

                            &:last-child {
                                border-right: none;
                                margin-right: 0;
                            }
                        }
                    }
                }
            }
            .line_bottom:last-child::after{
                background: none
            }
        }
    }
}
</style>
